export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14574.05cc335f.jpg";